module.exports = __webpack_public_path__ + "static/open-sans-bold-0edb76284a7a0f8db4665b560ee2b48f.woff2";